import { useStyles } from "@b2bportal/core-themes";
import { type CoreCarsComponent, CORE_CARS_NAME } from "@apac/cars";

export const useCarsStyles = (
  componentName: keyof typeof CoreCarsComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_CARS_NAME, componentName, defaultStyles);
};
